import React from 'react';
import { StoreInvoiceList } from '../InvoiceList/StoreInvoiceList';

type MerchantInvoiceTabProps = {
  externalPickpackId: string | null;
  title: string;
};

export const MerchantInvoiceTab = ({
  externalPickpackId,
  title,
}: MerchantInvoiceTabProps) => {
  return <StoreInvoiceList storeId={externalPickpackId} title={title} />;
};
